import React from 'react'

function NonTeachingStaff() {
  return (
    <div>NonTeachingStaff</div>
  )
}

export default NonTeachingStaff